module.exports = __webpack_public_path__ + "img/serviceplanner-banner.861ebb80.webp";